import {EnumIntegrationConnectorMessages} from "../../../Queries";

export const SystemMessages = [EnumIntegrationConnectorMessages.INIT, EnumIntegrationConnectorMessages.UPDATECONFIG]
